import React from 'react';
// template components
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export default () => {
  return (
    <SectionContainer
      id='delete-mobile-app-info'
      backgroundVariant='lightA'
      themeType='lightTheme'
      moduleName='intro-module'
      moduleVariation='A'>
      <Row align='center'>
        <Col
          medium={10}
          large={8}>
          <Typography
            component='h2'
            nextElement='typography'
            align='center'>
            If you have the mobile app installed
          </Typography>
          <Typography nextElement='typography'>
            If you are viewing this page on an Android or iOS device, click the following <strong>delete account</strong> link:{' '}
            <Link
              id='delete-mobile-app-link'
              variant='primaryDeemphasize'
              linkUrl='https://www.northwesternmutual.com/app/deleteaccount/'  // keep absolute path to preserve mobile deep linking
              ariaLabel='Instructions on how to delete the mobile app'
              isOutgoingLink>
              https:&#47;&#47;www.northwesternmutual.com&#47;app&#47;deleteaccount&#47;
            </Link>
          </Typography>
          <Typography nextElement='typography'>
            OR
          </Typography>
          <BulletedList
            bulletType='orderedDecimal'
            bulletedListData={[
              { bulletText: 'Sign in to the app.' },
              { bulletText: 'While on the home screen, tap the profile icon at the top right side of the screen.' },
              { bulletText: 'While on the profile screen, tap the settings icon at the top right of the screen.' },
              { bulletText: 'While on the settings screen, tap the Information option.' },
              { bulletText: 'While in the Information screen, tap the Account Deletion option.' },
              { bulletText: <>Press the &#34;Delete My Account&#34; button.</> },
            ]}
          />
        </Col>
      </Row>
    </SectionContainer>
  );
};
